import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewsfeedComponent } from './components/newsfeed/newsfeed.component';
import { NewsfeedNotificationComponent } from './components/newsfeed-notification/newsfeed-notification.component';
import { NewsfeedObservablePipe } from './pipes/newsfeed-observable.pipe';
import { UserModule } from '../user/user.module';
import { SharedModule } from '../shared/shared.module';
import { NewsfeedObservablePreviewPipe } from './pipes/newsfeed-observable-preview.pipe';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';



@NgModule({
  declarations: [
    NewsfeedComponent,
    NewsfeedNotificationComponent,
    NewsfeedObservablePipe,
    NewsfeedObservablePreviewPipe
  ],
  imports: [
    CommonModule,
    UserModule,
    SharedModule,
    MatProgressSpinnerModule
  ],
  exports: [
    NewsfeedComponent,
    NewsfeedObservablePipe
  ]
})
export class NewsfeedModule { }
